// File Icon Component with different types based on file extension
const FileIcon = ({ fileName }) => {
  const getFileExtension = (filename) => {
    if (!filename) return null;

    return filename.split('.').pop().toLowerCase();
  };

  const getFileType = (extension) => {
    const types = {
      pdf: 'pdf',
      doc: 'document',
      docx: 'document',
      xls: 'spreadsheet',
      xlsx: 'spreadsheet',
      csv: 'spreadsheet',
      png: 'image',
      jpg: 'image',
      jpeg: 'image',
      gif: 'image',
      svg: 'image',
      txt: 'text',
      zip: 'archive',
      rar: 'archive',
      '7z': 'archive'
    };
    return types[extension] || 'default';
  };

  const extension = getFileExtension(fileName);
  const fileType = getFileType(extension);

  // PDF Icon
  if (fileType === 'pdf') {
    return (
      <svg className="file-icon file-icon-pdf" width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" fill="#dc2626" stroke="#dc2626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <polyline points="14,2 14,8 20,8" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <text x="12" y="16" fontSize="6" fill="white" textAnchor="middle" fontWeight="bold">PDF</text>
      </svg>
    );
  }

  // Document Icon (DOC, DOCX)
  if (fileType === 'document') {
    return (
      <svg className="file-icon file-icon-document" width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" fill="#2563eb" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <polyline points="14,2 14,8 20,8" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <line x1="16" y1="13" x2="8" y2="13" stroke="white" strokeWidth="1"/>
        <line x1="16" y1="17" x2="8" y2="17" stroke="white" strokeWidth="1"/>
        <polyline points="10,9 9,9 8,9" stroke="white" strokeWidth="1"/>
      </svg>
    );
  }

  // Spreadsheet Icon (XLS, XLSX, CSV)
  if (fileType === 'spreadsheet') {
    return (
      <svg className="file-icon file-icon-spreadsheet" width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" fill="#059669" stroke="#059669" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <polyline points="14,2 14,8 20,8" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <rect x="8" y="11" width="8" height="6" fill="none" stroke="white" strokeWidth="1"/>
        <line x1="12" y1="11" x2="12" y2="17" stroke="white" strokeWidth="1"/>
        <line x1="8" y1="14" x2="16" y2="14" stroke="white" strokeWidth="1"/>
      </svg>
    );
  }

  // Image Icon (PNG, JPG, etc.)
  if (fileType === 'image') {
    return (
      <svg className="file-icon file-icon-image" width="16" height="16" viewBox="0 0 24 24" fill="none">
        <rect x="3" y="3" width="18" height="18" rx="2" ry="2" fill="#7c3aed" stroke="#7c3aed" strokeWidth="2"/>
        <circle cx="8.5" cy="8.5" r="1.5" fill="white"/>
        <polyline points="21,15 16,10 5,21" stroke="white" strokeWidth="2" fill="none"/>
      </svg>
    );
  }

  // Archive Icon (ZIP, RAR, 7Z)
  if (fileType === 'archive') {
    return (
      <svg className="file-icon file-icon-archive" width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" fill="#ea580c" stroke="#ea580c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <polyline points="14,2 14,8 20,8" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <rect x="9" y="12" width="6" height="4" fill="none" stroke="white" strokeWidth="1"/>
        <circle cx="12" cy="14" r="1" fill="white"/>
      </svg>
    );
  }

  // Default File Icon
  return (
    <svg className="file-icon file-icon-default" width="16" height="16" viewBox="0 0 24 24" fill="none">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" fill="#64748b" stroke="#64748b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <polyline points="14,2 14,8 20,8" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

export default FileIcon;
